import { render } from "./PanelWrapper.vue?vue&type=template&id=4eb31490&lang=pug"
import script from "./PanelWrapper.vue?vue&type=script&lang=js"
export * from "./PanelWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__